<template>
  <div class="u-parse-h5" v-html="content" />
</template>

<script>
/**
 * 小程序 u-parse 占位：富文本来自活动配置，与后台可控范围一致。
 */
export default {
  name: 'u-parse',
  props: {
    content: { type: String, default: '' },
    scrollTable: { type: Boolean, default: false },
    tagStyle: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped>
.u-parse-h5 {
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}
</style>
